module.exports = __webpack_public_path__ + "schaffhausen.svg?ee88194a8f8f7ff875118d37be4bb925";